import { Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('notFound.title')}
      </Typography>
      <Button component={RouterLink} to="/chats" variant="contained">
        {t('notFound.home')}
      </Button>
    </Container>
  );
}
